var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "shortcutComponent",
    {
      ref: "shortcutComponent",
      attrs: { modalClass: "ld-modal", showBtnOk: false },
    },
    [
      _c("div", { attrs: { slot: "component" }, slot: "component" }, [
        _c("form", { attrs: { novalidate: "novalidate" } }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-12" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "label",
                    { staticClass: "control-label", attrs: { for: "credito" } },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$t("__.Crud.cliente.credito_vue_html.credito")
                          ) +
                          "\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("moeda-component", {
                    staticClass: "form-control",
                    attrs: { id: "credito", name: "credito", disabled: "" },
                    model: {
                      value: _vm.credito,
                      callback: function ($$v) {
                        _vm.credito = $$v
                      },
                      expression: "credito",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }